var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-info"},[(_vm.userInfo)?_c('img',{staticClass:"avatar",attrs:{"src":_vm.userInfo.Avatar}}):_c('img',{staticClass:"avatar",attrs:{"src":require("@/assets/icon/avatar.jpg")}}),_c('div',{staticClass:"name"},[_vm._v(" "+_vm._s(_vm.userInfo?.Name || 'Joan Doe')+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }